document.addEventListener("DOMContentLoaded", function () {
  const selectedItemsStep1 = document.getElementById("step1-items");
  const selectedItemsStep2 = document.getElementById("step2-items");
  const selectedItemsStep3 = document.getElementById("step3-items");
  const finalUrlDiv = document.querySelector(".final-url");
  
  const progressBar = document.querySelector(".progress-bar");
  const progressLabel = document.querySelector(".progress-label");
  const goalPrice = 350; // Hedef fiyat
  let selectedProducts = []; // Seçilen ürünlerin bilgileri

  // Disable/Enable other boxes based on whether a box is already selected
  function updateStep1ButtonsState() {
    const step1Buttons = document.querySelectorAll(".select-product-step-1");
    const boxCount = selectedItemsStep1 ? selectedItemsStep1.children.length : 0;
    
    step1Buttons.forEach(btn => {
      if (boxCount >= 1) {
        btn.disabled = true;
        btn.style.opacity = "0.5";
        btn.style.cursor = "not-allowed";
        const span = btn.querySelector(".desktop");
        if (span) span.textContent = "Seçildi";
      } else {
        btn.disabled = false;
        btn.style.opacity = "1";
        btn.style.cursor = "pointer";
        const span = btn.querySelector(".desktop");
        if (span) span.textContent = "Ekle";
      }
    });
  }

  // Check Shopify cart dynamically to determine the next sequential box number
  async function getNextBoxNumber() {
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      let maxNumber = 0;
      if (cartData && cartData.items) {
        cartData.items.forEach(item => {
          if (item.properties && item.properties["Kutu Grubu"]) {
            const match = item.properties["Kutu Grubu"].match(/Kutu\s*#\s*(\d+)/i);
            if (match) {
              const num = parseInt(match[1]);
              if (num > maxNumber) {
                maxNumber = num;
              }
            }
          }
        });
      }
      return maxNumber + 1;
    } catch (e) {
      console.error("Cart check error:", e);
      return Math.floor(1000 + Math.random() * 9000); // Fallback to random number on error
    }
  }

  async function selectProduct(stepItems, productHandle, isVariant, variantIdOverride) {
    let selectedVariantId = null;

    if (isVariant) {
      if (variantIdOverride) {
        selectedVariantId = variantIdOverride;
      } else {
        const variantSelector = document.querySelector(
          `.variant-selector[data-handle='${productHandle}']`
        );
        selectedVariantId = variantSelector ? variantSelector.value : null;
      }
    }

    // Only allow 1 box to be selected
    if (stepItems === selectedItemsStep1) {
      const boxCount = selectedItemsStep1 ? selectedItemsStep1.children.length : 0;
      if (boxCount >= 1) {
        alert("Sadece 1 adet kutu seçebilirsiniz.");
        return;
      }
    }

    try {
      const productData = await fetchProduct(productHandle);
      if (!productData || !productData.variants || productData.variants.length === 0) {
        console.error("Ürün verisi alınamadı veya varyant bulunamadı:", productHandle);
        return;
      }

      let variantData = null;
      if (isVariant) {
        if (selectedVariantId) {
          variantData = productData.variants.find(
            (variant) => variant.id === parseInt(selectedVariantId)
          );
        }
        if (!variantData && productData.variants.length > 0) {
          variantData = productData.variants[0];
        }
      } else {
        variantData = productData.variants[0];
      }

      if (!variantData) {
        console.error("Varyant bulunamadı:", productHandle, isVariant, selectedVariantId);
        return;
      }

      const customTextInput = document.getElementById(
        `${productHandle}-urun-uzerindeki-yazi`
      );
      const customLetterInput = document.getElementById(
        `${productHandle}-urun-uzerindeki-harf`
      );
      const customImageInput = document.getElementById(
        `${productHandle}-urun-uzerindeki-resim`
      );

      const customText = customTextInput ? customTextInput.value.trim() : "";
      const customLetter = customLetterInput ? customLetterInput.value.trim() : "";
      const customImage =
        customImageInput && customImageInput.files && customImageInput.files[0]
          ? customImageInput.files[0]
          : null;

      const listItem = createListItem(
        productData.title,
        productData.image,
        variantData.price,
        variantData.id,
        customText,
        customLetter,
        customImage
      );
      stepItems.appendChild(listItem);

      if (stepItems === selectedItemsStep1) {
        updateStep1ButtonsState();
        // Switch from box-select view to products view
        const view1 = document.getElementById("step-view-1");
        const view2 = document.getElementById("step-view-2");
        if (view1 && view2) {
          view1.style.opacity = "0";
          view1.style.transition = "opacity 0.3s ease";
          setTimeout(() => {
            view1.style.display = "none";
            view2.style.display = "block";
            view2.style.opacity = "0";
            view2.style.transition = "opacity 0.3s ease";
            requestAnimationFrame(() => {
              view2.style.opacity = "1";
            });
            // Scroll to top of product view
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);
          }, 300);
        }
      }

      if (stepItems === selectedItemsStep3) {
        // Kart seçilince otomatik olarak teslimat adımına geç
        switchStepView(
          document.getElementById("step-view-3"),
          document.getElementById("step-view-4")
        );
      }

      const existingProduct = selectedProducts.find(
        (product) => product.id === variantData.id
      );

      if (existingProduct) {
        existingProduct.quantity += 1;
      } else {
        selectedProducts.push({
          id: variantData.id,
          title: productData.title,
          image: productData.image,
          price: variantData.price,
          customText: customText,
          customLetter: customLetter,
          customImage: customImage,
          quantity: 1,
        });
      }

      updateFinalUrl();
      updateTotalPriceAndProgress();

      // Clear inputs
      if (customTextInput) {
        customTextInput.value = "";
      }
      if (customLetterInput) {
        customLetterInput.value = "";
      }
      if (customImageInput) {
        customImageInput.value = "";
      }
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  }

  function updateFinalUrl() {
    finalUrlDiv.innerHTML = "";
    selectedProducts.forEach((product) => {
      let finalUrl = `add?id=${product.id}&quantity=${product.quantity}`;
      if (product.customText)
        finalUrl += `&properties[Ürün üzerindeki yazı]=${encodeURIComponent(
          product.customText
        )}`;
      if (product.customLetter)
        finalUrl += `&properties[Ürün üzerindeki harf]=${encodeURIComponent(
          product.customLetter
        )}`;

      const productUrlElement = document.createElement("div");
      productUrlElement.textContent = finalUrl;
      finalUrlDiv.appendChild(productUrlElement);
    });
  }

  function updateProductQuantity(productId, newQuantity) {
    const product = selectedProducts.find((item) => item.id === productId);
    if (product) {
      product.quantity = newQuantity > 0 ? newQuantity : 1;
      updateFinalUrl();
      updateTotalPriceAndProgress();
    }
  }

  function updateTotalPriceAndProgress() {
    const totalPrice = selectedProducts.reduce(
      (sum, product) => sum + product.price * product.quantity,
      0
    );

    const totalPriceElements = document.querySelectorAll(".total-price");
    totalPriceElements.forEach((element) => {
        element.textContent = `Toplam Fiyat: ${totalPrice.toFixed(2)} TL`;
    });

    const progress = Math.min((totalPrice / goalPrice) * 100, 100);
    progressBar.style.width = `${progress}%`;

    const remaining = Math.max(goalPrice - totalPrice, 0);
    progressLabel.textContent = remaining > 0
      ? `Ücretsiz kargo için kalan: ${remaining.toFixed(2)} TL`
      : "Kargo Bedava! 🎉";

    // Update bottom sticky cart bar quantity badge dynamically
    const totalQty = selectedProducts.reduce((sum, p) => sum + p.quantity, 0);
    const badge = document.querySelector(".gift-badge");
    if (badge) {
      badge.textContent = totalQty;
    }
  }

  function createListItem(
    productTitle,
    productImage,
    productPrice,
    variantId,
    customText,
    customLetter,
    customImage
  ) {
    const listItem = document.createElement("li");

    listItem.innerHTML = `
      <div class="line-item">
      <div class="imgae-side">
      <img src="${productImage}" alt="${productTitle}" class="product-image" style="width: 50px; height: 50px; margin-right: 10px;" />
      </div>
      <div class="details">
      <div class="urun-adi"><span class="eklenen-urun">${productTitle}</span></div>
      <div class="urun-fiyat-mikatar-cop">
      <span class="product-each-price">${productPrice} TL</span>
      <div class="miktar-ayar">
      <button class="decrease-quantity">-</button>
      <input type="number" class="product-quantity" value="1" min="1" />
      <button class="increase-quantity">+</button>
      </div>
      <button class="remove-item"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 60.167 60.167">
<path d="M54.5,11.667H39.88V3.91c0-2.156-1.754-3.91-3.91-3.91H24.196c-2.156,0-3.91,1.754-3.91,3.91v7.756H5.667  c-0.552,0-1,0.448-1,1s0.448,1,1,1h2.042v40.5c0,3.309,2.691,6,6,6h32.75c3.309,0,6-2.691,6-6v-40.5H54.5c0.552,0,1-0.448,1-1  S55.052,11.667,54.5,11.667z M22.286,3.91c0-1.053,0.857-1.91,1.91-1.91H35.97c1.053,0,1.91,0.857,1.91,1.91v7.756H22.286V3.91z   M50.458,54.167c0,2.206-1.794,4-4,4h-32.75c-2.206,0-4-1.794-4-4v-40.5h40.75V54.167z M38.255,46.153V22.847c0-0.552,0.448-1,1-1  s1,0.448,1,1v23.306c0,0.552-0.448,1-1,1S38.255,46.706,38.255,46.153z M29.083,46.153V22.847c0-0.552,0.448-1,1-1s1,0.448,1,1  v23.306c0,0.552-0.448,1-1,1S29.083,46.706,29.083,46.153z M19.911,46.153V22.847c0-0.552,0.448-1,1-1s1,0.448,1,1v23.306  c0,0.552-0.448,1-1,1S19.911,46.706,19.911,46.153z"/>
</svg></button>
      </div>
      </div>
    `;

    listItem.querySelector(".increase-quantity").addEventListener("click", () => {
      const quantityInput = listItem.querySelector(".product-quantity");
      quantityInput.value = parseInt(quantityInput.value) + 1;
      updateProductQuantity(variantId, parseInt(quantityInput.value));
    });

    listItem.querySelector(".decrease-quantity").addEventListener("click", () => {
      const quantityInput = listItem.querySelector(".product-quantity");
      quantityInput.value = Math.max(1, parseInt(quantityInput.value) - 1);
      updateProductQuantity(variantId, parseInt(quantityInput.value));
    });

    listItem.querySelector(".product-quantity").addEventListener("input", (e) => {
      updateProductQuantity(variantId, parseInt(e.target.value));
    });

    listItem.querySelector(".remove-item").addEventListener("click", function () {
      const isBox = listItem.parentNode === selectedItemsStep1;
      listItem.remove();
      selectedProducts = selectedProducts.filter((product) => product.id !== variantId);
      updateFinalUrl();
      updateTotalPriceAndProgress();
      if (isBox) {
        updateStep1ButtonsState();
        const boxModal = document.getElementById("box-select-modal");
        if (boxModal) {
          boxModal.style.display = "flex";
        }
      }
    });

    return listItem;
  }

  function fetchProduct(productHandle) {
    return fetch(`/products/${productHandle}.json`)
      .then((response) => response.json())
      .then((data) => ({
        title: data.product.title,
        variants: data.product.variants,
        image: data.product.images[0]?.src || "",
      }));
  }

  // Click delegation
  document.addEventListener("click", function (event) {
    const targetButton = event.target.closest(
      ".select-product-step-1, .select-product-step-2, .select-product-step-3"
    );
    if (!targetButton || targetButton.disabled) return;

    const productHandle = targetButton.getAttribute("data-handle");
    if (!productHandle) return;

    const isVariant = targetButton.getAttribute("data-is-variant") === "true";

    const container = targetButton.closest(
      ".detailed-view, .details, .product-list-item, .box-card"
    );
    const variantSelector = container
      ? container.querySelector(`.variant-selector[data-handle='${productHandle}']`)
      : null;
    const variantIdOverride = variantSelector ? variantSelector.value : null;

    let finalVariantId = variantIdOverride;
    if (!finalVariantId && isVariant) {
      const docSelector = document.querySelector(`.variant-selector[data-handle='${productHandle}']`);
      if (docSelector) {
        finalVariantId = docSelector.value;
      }
    }

    if (targetButton.classList.contains("select-product-step-1")) {
      if (selectedItemsStep1) {
        selectProduct(selectedItemsStep1, productHandle, isVariant, finalVariantId);
      }
      return;
    }

    if (targetButton.classList.contains("select-product-step-2")) {
      if (selectedItemsStep2) {
        selectProduct(selectedItemsStep2, productHandle, isVariant, finalVariantId);
      }
      return;
    }

    if (targetButton.classList.contains("select-product-step-3")) {
      if (selectedItemsStep3) {
        selectProduct(selectedItemsStep3, productHandle, isVariant, finalVariantId);
      }
    }
  });

  // Seçilen ürünleri sepete ekler. Görsel yükleyen ürünler var mı yok mu farketmeksizin
  // tek bir yerden çağrılır - "Sepete Ekle" ve "Ekle ve Yeni Kutu" butonları bunu paylaşır.
  //
  // Görsel line-item-property'si Shopify'da yalnızca multipart/form-data ile çalışıyor;
  // /cart/add.js'in JSON toplu ekleme modu dosya kabul etmiyor. Bu yüzden görseli olan
  // ürünler tek tek FormData ile, geri kalanı ise öncekiyle aynı toplu JSON isteğiyle eklenir.
  async function addSelectedProductsToCart() {
    const boxNum = await getNextBoxNumber();
    const boxToken = "Kutu #" + boxNum;

    const jsonItems = [];
    const fileItems = [];

    selectedProducts.forEach((product) => {
      const itemProperties = {
        "Kutu Grubu": boxToken
      };
      if (product.customText) {
        itemProperties["Ürün üzerindeki yazı"] = product.customText;
      }
      if (product.customLetter) {
        itemProperties["Ürün üzerindeki harf"] = product.customLetter;
      }

      if (product.customImage) {
        fileItems.push({
          id: product.id,
          quantity: product.quantity,
          properties: itemProperties,
          image: product.customImage,
        });
      } else {
        jsonItems.push({
          id: product.id,
          quantity: product.quantity,
          properties: itemProperties,
        });
      }
    });

    if (jsonItems.length > 0) {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: jsonItems }),
      });
      if (!response.ok) throw new Error("Failed to add items to cart");
    }

    for (const item of fileItems) {
      const formData = new FormData();
      formData.append("id", item.id);
      formData.append("quantity", item.quantity);
      Object.entries(item.properties).forEach(([key, value]) => {
        formData.append(`properties[${key}]`, value);
      });
      formData.append("properties[Ürün üzerindeki görsel]", item.image, item.image.name);

      // Content-Type header bilerek set edilmiyor: FormData ile fetch, boundary'yi
      // kendisi ekleyerek multipart/form-data header'ını otomatik oluşturur.
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });
      if (!response.ok) throw new Error("Failed to add item with image to cart");
    }
  }

  const addToCartBtn = document.getElementById("add-to-cart");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", async function () {
      if (selectedProducts.length === 0) {
        alert("Sepete eklemek için ürün seçmelisiniz.");
        return;
      }

      addToCartBtn.disabled = true;
      const originalText = addToCartBtn.textContent;
      addToCartBtn.textContent = "Ekleniyor...";

      try {
        await addSelectedProductsToCart();
        window.location.href = "/cart";
      } catch (error) {
        console.error("Error adding items to cart:", error);
        alert("Hata: Ürün sepete eklenemedi.");
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = originalText;
      }
    });
  }

  // Görünümler arası geçiş: bir #step-view-N'i gizleyip diğerini fade ile gösterir
  function switchStepView(fromEl, toEl) {
    if (!fromEl || !toEl) return;
    fromEl.style.opacity = "0";
    fromEl.style.transition = "opacity 0.25s ease";
    setTimeout(() => {
      fromEl.style.display = "none";
      toEl.style.display = "block";
      toEl.style.opacity = "0";
      toEl.style.transition = "opacity 0.25s ease";
      requestAnimationFrame(() => {
        toEl.style.opacity = "1";
      });
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }, 250);
  }

  // "Devam Et: Tebrik Kartı" - 2. adımdan 3. adıma (kart seçimi) geçer
  const selectCartBtn = document.getElementById("select-cart");
  if (selectCartBtn) {
    selectCartBtn.addEventListener("click", function () {
      if (selectedProducts.length === 0) {
        alert("Devam etmek için en az bir ürün seçmelisiniz.");
        return;
      }

      switchStepView(
        document.getElementById("step-view-2"),
        document.getElementById("step-view-3")
      );
    });
  }

  // "Devam Et: Teslimat Seçimi" - 3. adımdan 4. adıma (teslimat widget'ı) geçer, kart adımı opsiyonel
  const continueToDeliveryBtn = document.getElementById("continue-to-delivery");
  if (continueToDeliveryBtn) {
    continueToDeliveryBtn.addEventListener("click", function () {
      switchStepView(
        document.getElementById("step-view-3"),
        document.getElementById("step-view-4")
      );
    });
  }

  // Geri butonları
  const backToStep2Btn = document.getElementById("back-to-step2");
  if (backToStep2Btn) {
    backToStep2Btn.addEventListener("click", function () {
      switchStepView(
        document.getElementById("step-view-3"),
        document.getElementById("step-view-2")
      );
    });
  }

  const backToStep3Btn = document.getElementById("back-to-step3");
  if (backToStep3Btn) {
    backToStep3Btn.addEventListener("click", function () {
      switchStepView(
        document.getElementById("step-view-4"),
        document.getElementById("step-view-3")
      );
    });
  }

  const addAndNewBtn = document.getElementById("add-and-new");
  if (addAndNewBtn) {
    addAndNewBtn.addEventListener("click", async function () {
      if (selectedProducts.length === 0) {
        alert("Sepete eklemek için ürün seçmelisiniz.");
        return;
      }

      addAndNewBtn.disabled = true;
      const originalText = addAndNewBtn.textContent;
      addAndNewBtn.textContent = "Ekleniyor...";

      try {
        await addSelectedProductsToCart();
        // Clear current box state and reload builder page
        window.location.href = "/collections/kendi-kutunu-yap";
      } catch (error) {
        console.error("Error adding items to cart:", error);
        alert("Hata: Ürün sepete eklenemedi.");
        addAndNewBtn.disabled = false;
        addAndNewBtn.textContent = originalText;
      }
    });
  }

  // "Sepete Ekle ve Bölgenize Gönderilebilen Çiçekleri Görüntüleyin": kutuyu
  // (teslimat bilgisiyle - bkz. AGT fetch interceptor'ı) sepete ekleyip canlı çiçek
  // koleksiyonuna gönderir; müşteri aynı adrese çiçek de ekleyebilsin diye.
  const addAndViewFlowersBtn = document.getElementById("add-and-view-flowers");
  if (addAndViewFlowersBtn) {
    addAndViewFlowersBtn.addEventListener("click", async function () {
      if (selectedProducts.length === 0) {
        alert("Sepete eklemek için ürün seçmelisiniz.");
        return;
      }

      addAndViewFlowersBtn.disabled = true;
      const originalText = addAndViewFlowersBtn.textContent;
      addAndViewFlowersBtn.textContent = "Ekleniyor...";

      try {
        await addSelectedProductsToCart();
        window.location.href = "/collections/canli-cicekler";
      } catch (error) {
        console.error("Error adding items to cart:", error);
        alert("Hata: Ürün sepete eklenemedi.");
        addAndViewFlowersBtn.disabled = false;
        addAndViewFlowersBtn.textContent = originalText;
      }
    });
  }

  // --- KALAN KUTULARI YÜKLE ---
  // Liquid sayfa başına en fazla 50 ürün render ediyor (bkz. şablondaki
  // paginate notu). Koleksiyonda daha fazla kutu varsa geri kalanını burada
  // arka planda çekip listeye ekliyoruz, yoksa o kutular hiç seçilemiyor.
  async function loadRemainingBoxes() {
    const grid = document.querySelector("#step-view-1 .box-select-grid");
    let button = document.querySelector(".box-load-more");
    if (!grid || !button) return;

    // Koleksiyon beklenmedik şekilde büyürse sonsuz döngüye girmeyelim.
    let guard = 0;

    while (button && guard++ < 20) {
      const nextPageUrl = button.getAttribute("data-next-page");
      if (!nextPageUrl) break;

      try {
        const response = await fetch(nextPageUrl);
        if (!response.ok) throw new Error("HTTP " + response.status);

        const doc = new DOMParser().parseFromString(await response.text(), "text/html");

        doc.querySelectorAll(".box-select-grid .box-card").forEach((card) => {
          // Aynı kutu iki kez eklenmesin.
          if (card.id && document.getElementById(card.id)) return;
          grid.appendChild(card);
        });

        const nextButton = doc.querySelector(".box-load-more");
        if (nextButton && nextButton.getAttribute("data-next-page")) {
          button.setAttribute("data-next-page", nextButton.getAttribute("data-next-page"));
        } else {
          button.remove();
          button = null;
        }
      } catch (error) {
        console.error("Kalan kutular yüklenemedi:", error);
        // Otomatik yükleme başarısız: butonu göster, kullanıcı elle deneyebilsin.
        button.style.display = "";
        button.textContent = "Kalan Kutuları Göster";
        return;
      }
    }

    updateStep1ButtonsState();
  }

  const boxLoadMoreBtn = document.querySelector(".box-load-more");
  if (boxLoadMoreBtn) {
    boxLoadMoreBtn.addEventListener("click", function () {
      boxLoadMoreBtn.textContent = "Yükleniyor...";
      loadRemainingBoxes();
    });
  }

  loadRemainingBoxes();

  // Check state on load
  updateStep1ButtonsState();

  // --- VIEW SWITCHING LOGIC ---
  // If box is removed from sidebar, go back to step-view-1
  function checkAndSwitchToBoxView() {
    const step1List = document.querySelector("#step1-items");
    const hasBox = step1List && step1List.children.length > 0;
    const view1 = document.getElementById("step-view-1");
    const view2 = document.getElementById("step-view-2");
    if (!hasBox && view1 && view2) {
      view2.style.opacity = "0";
      view2.style.transition = "opacity 0.25s ease";
      setTimeout(() => {
        view2.style.display = "none";
        view1.style.display = "block";
        view1.style.opacity = "0";
        view1.style.transition = "opacity 0.25s ease";
        requestAnimationFrame(() => {
          view1.style.opacity = "1";
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 250);
    }
  }

  // "Kutular" link now switches back to view 1
  document.addEventListener("click", function (e) {
    const boxLink = e.target.closest('a[href="#kutular"]');
    if (boxLink) {
      e.preventDefault();
      const step1List = document.querySelector("#step1-items");
      const hasBox = step1List && step1List.children.length > 0;
      if (!hasBox) {
        checkAndSwitchToBoxView();
      }
    }
  });

  // Watch for box removal to switch back to view 1
  const step1ListEl = document.querySelector("#step1-items");
  if (step1ListEl) {
    const viewObserver = new MutationObserver(() => {
      setTimeout(checkAndSwitchToBoxView, 100);
    });
    viewObserver.observe(step1ListEl, { childList: true });
  }
});
